// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import truckVideo from './Images/truck1.mp4';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <video
        autoPlay
        muted
        loop
        playsInline
        className="background-video"
      >
        <source src={truckVideo} type="video/mp4" />
      </video>
    <App />
  </React.StrictMode>
);